import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './Card.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'post /user/cards': 200,
    // 'get /user/cards': 200,
    // 'delete /user/cards': 200,
  })
}

export const postToken = accessToken =>
  client({
    url: '/user/cards',
    method: 'post',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const getAllCards = accessToken =>
  client({
    url: '/user/cards',
    method: 'get',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })

export const deleteCard = (id, accessToken) =>
  client({
    url: `/user/cards/${encodeURIComponent(id)}`,
    method: 'delete',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Device-Id': generateDeviceId(),
    },
  })
